import React, { useState, useEffect } from "react";
import AthleteLayout from "../common/AthleteLayout";
import { useAthleteAuthContext } from "../login/useAthleteAuthContext";
import { useNavigate, useParams, Link } from "react-router-dom";
import { AthleteHeader } from "../common/AthleteHeader";
import API_URL from "../../api/API";
import bgImg from "../../images/runRocket.jpeg";


export const AthleteRunrocketTrainingWeeks = () => {
  const { athlete } = useAthleteAuthContext();
  const navigate = useNavigate();
  const { template_id } = useParams();

  const [openIndex, setOpenIndex] = useState(null); // Accordion state
  const [weeks, setWeeks] = useState([]); // Store weeks data
  const [isLoading, setIsLoading] = useState(true); // Loading state
  const [error, setError] = useState(null); // Error state

  // Toggle accordion logic
  const toggleAccordion = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  // Fetch training data from the API
  const fetchTrainingData = async () => {
    try {
      const response = await fetch(
        `${API_URL.GET_RUNROCKET_TRAINING_TEMPLATE_FRONT_WEEKS}${template_id}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${athlete.token}`,
          },
        },
      );
      if (!response.ok) {
        throw new Error("Failed to fetch training data");
      }
      const data = await response.json();
      console.log(data);
      setWeeks(data); // Set the weeks data
      setIsLoading(false); // Set loading to false after data is fetched
    } catch (error) {
      setError(error.message); // Handle errors
      setIsLoading(false); // Set loading to false in case of error
    }
  };

  // Fetch data when the component mounts
  useEffect(() => {
    fetchTrainingData();
  }, [template_id, athlete.token]); // Re-fetch if template_id or token changes

  return (
    <AthleteLayout>
      <div className="relative h-full bg-white pb-5 overflow-y-auto">
        <div className="w-full max-w-screen-xl mx-auto border-t border-black/30 mt-2"></div>
        {/* background image if need again */}
        {/* <div className="absolute inset-0">
          <img src={bgImg} alt="bgImg" className="object-cover w-full h-full" />
          <div className="w-full h-full absolute inset-0 bg-white/70"></div>
        </div> */}
        <div className="relative w-full max-w-2xl mx-auto pt-5 px-5">
          <div className="bg-black rounded-2xl flex justify-between gap-8 px-4 py-4 mb-5">
            <span
              onClick={() => navigate("/athlete/tools/runrocket/test/result")}
              className="text-white/40 text-sm xs:text-base cursor-pointer"
            >
              Test
            </span>
            <span className="text-white text-sm xs:text-base cursor-pointer  hover:text-white transitionsss">
              Train
            </span>
            <span
              onClick={() =>
                navigate("/athlete/tools/runrocket/performance/" + template_id)
              }
              className="text-white/40 text-sm xs:text-base cursor-pointer  hover:text-white transitionsss"
            >
              Performance
            </span>
          </div>
        </div>

        <div className={`relative w-full max-w-2xl mx-auto py-4 px-5 space-y-5`}>
          {isLoading ? (
            <div className="pt-3">Loading training weeks...</div>
          ) : error ? (
            <div className="text-red-500 pt-2">{error}</div>
          ) : (
            weeks.map((week, index) => (
              <div
                key={index}
                className={`${openIndex === index && "!border-black/30"} bg-white border border-black rounded-xl`}
              >
                {/* Accordion button */}
                <button
                  className="w-full flex justify-between items-center gap-5 text-white text-base font-bold bg-black text-left px-4 py-3 rounded-lg"
                  onClick={() => toggleAccordion(index)}
                >
                  <p>{week.week_number}</p>
                  <span className={`transform transition-transform `}>
                    {/* <ArrowD /> */}
                    {openIndex === index ? (
                      <>
                        <Minus />
                      </>
                    ) : (
                      <>
                        <Plus />
                      </>
                    )}
                  </span>
                </button>
                {/* Inner items */}
                {openIndex === index && (
                  <div className="px-10 py-3">

                  {(week.week_number === "Week 8" || week.week_number === 8) && (
                        <div className="mb-5 rounded-lg border border-[#C19E42] bg-[#FFF8E8] p-4">
                          <h4 className="text-[#C19E42] text-base font-semibold mb-2">
                            Ready to Retest?
                          </h4>

                          <p className="text-sm text-black leading-6">
                            Once you have completed <strong>Week 8</strong>, you should retake your
                            <strong> AST Speed Profile</strong> to receive an updated
                            <strong> Training Focus</strong> and your next recommended training plan
                            based on your latest results.
                          </p>

                          <p className="mt-3 text-sm text-black leading-6">
                            <strong>Important:</strong> Retesting will permanently reset your current
                            Speed Profile. Your previous test results, training focus, and all
                            associated training data will no longer be available. This action
                            cannot be undone.
                          </p>
                        </div>
                      )}



                    {week.days.map((day, i) => (
                      
                      <div
                      key={i}
                      className="py-3 border-b border-black/10 last:border-b-0"
                    >
                      <Link
                        to={`/athlete/tools/runrocket/training/week-day/${week.week_number + " => " + day.day}/${day._id}`}
                        className="flex flex-col gap-1"
                      >
                        <span className="text-black text-base font-medium">
                          {day.day}
                        </span>
                    
                        <span className="text-xs text-black/50 uppercase tracking-wide">
                          {day.training_focus}
                        </span>
                      </Link>
                    </div>
                    
                    ))}
                  </div>
                )}
              </div>
            ))
          )}
        </div>
      </div>
    </AthleteLayout>
  );
};

const ArrowD = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="8"
    viewBox="0 0 14 8"
    fill="none"
  >
    <path
      d="M13 1L7 7L1 1"
      stroke="black"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const Plus = () => {
  return (
    <svg
      width="24"
      className="w-full h-full"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      preserveAspectRatio="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M0 0H24V24H0V0Z" fill="#C19E42" />
      <path d="M11 4.5H13V19.5H11V4.5Z" fill="black" />
      <path d="M4.5 13V11H19.5V13H4.5Z" fill="black" />
    </svg>
  );
};

const Minus = () => {
  return (
    <svg
      width="24"
      className="w-full h-full"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      preserveAspectRatio="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M0 0H24V24H0V0Z" fill="#C19E42" />
      {/* <path d="M10.5 4H13.5V20H10.5V4Z" fill="black" /> */}
      <path d="M4.5 13V11H19.5V13H4.5Z" fill="black" />
    </svg>
  );
};
